import { mapState } from 'vuex';

export const filtering = {
	computed: {
		...mapState('playbooks', ['filters', 'search', 'sort']),
		/**
		 * Determine if we currently have filters set.
		 *
		 * @returns {boolean} true if we have filters, false otherwise.
		 */
		isFiltering() {
			return ['categories', 'goals', 'tags'].some((filter) => {
				return 0 !== this.filters[filter].length;
			});
		},
		/**
		 * Determine if we have a search string set.
		 *
		 * @returns {boolean} true if we have a search string, false otherwise.
		 */
		isSearching() {
			return '' !== this.search;
		},
		/**
		 * Determine if we have a sort set.
		 *
		 * @returns {boolean} true if we have a sort, false otherwise.
		 */
		isSorting() {
			return '' !== this.sort;
		},
	},
	methods: {
		/**
		 * Resets the search value in state to empty
		 *
		 * @returns {void}
		 */
		clearSearch() {
			this.$store.commit('playbooks/setSearch', '');
		},
		/**
		 * Resets the filters value to none
		 *
		 * @returns {void}
		 */
		clearFilters() {
			this.clearSearch();
			this.$store.commit('playbooks/clearFilters');
		},
	},
};
